import { atomWithRefresh } from "../utils";
import { AllPlansType } from "../types";

export interface InterfacesApiResponse {
  currentInterfacesAccountProjectCount: number;
  currentInterfacesAccountProjectLimit: number;
  currentInterfacesPlanName: AllPlansType;
  needsToUpgrade: boolean;
}

export const interfacesUsageAtom_SUSPENDS = atomWithRefresh<
  Promise<InterfacesApiResponse | null>
>(async () => {
  try {
    const response = await fetch(`/api/canvasui/interfaces`);

    if (!response.ok) {
      return null;
    }

    const responseData: InterfacesApiResponse = await response.json();
    return responseData;
  } catch (error) {
    return null;
  }
});

interfacesUsageAtom_SUSPENDS.debugLabel = "interfacesUsageAtom_SUSPENDS";
